<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-medkit"></i> Mediclaim Information</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->

            <div class="row row-replace">
                <div class="col-md-6 card pt-10">
                    <h3 class="card-title page-header0"><i class="fa fa-user"></i> Personal Informations</h3>
                    <hr>
                  <div class="form-group">
                      <div class="row">
                          <div class="col-4">
                              <label for="aaaa">S.No<span class="text-danger">*</span></label>
                          </div>
                          <div class="col-8">
                             <input type="text" class="form-control">
                          </div>
                      </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                        <div class="col-4">
                            <label for="aaaa">Employee Code<span class="text-danger">*</span></label>
                        </div>
                        <div class="col-8">
                           <input type="text" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-4">
                            <label for="aaaa">Employee Name<span class="text-danger">*</span></label>
                        </div>
                        <div class="col-8">
                           <input type="text" class="form-control">
                        </div>
                    </div>
                </div>
                
                  <div class="form-group">
                      <div class="row">
                          <div class="col-4">
                              <label for="aaaa">DOB<span class="text-danger">*</span></label>
                          </div>
                          <div class="col-8">
                            <input type="date" class="form-control">
                          </div>
                      </div>
                  </div>
                  <div class="form-group">
                      <div class="row">
                          <div class="col-4">
                              <label for="aaaa">Relationship<span class="text-danger">*</span></label>
                          </div>
                          <div class="col-8">
                           <select class="form-control">
                            <option>Self</option>
                            <option>Wife</option>
                            <option>Daughter</option>
                            <option>Son</option>
                           </select>
                          </div>
                      </div>
                  </div>
                  <div class="form-group">
                      <div class="row">
                          <div class="col-4">
                              <label for="aaaa">Gender<span class="text-danger">*</span></label>
                          </div>
                          <div class="col-8">
                            <select class="form-control">
                                <option>Male</option>
                                <option>Female</option>
                               </select>
                          </div>
                      </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                        <div class="col-4">
                            <label for="aaaa">Marital Status<span class="text-danger">*</span></label>
                        </div>
                        <div class="col-8">
                     <select class="form-control">
                        <option>Married</option>
                        <option>Unmarried</option>
                     </select>
                        </div>
                    </div>
                </div>
                  
                  
                 

                </div>



                <div class="col-md-6 card pt-10">
                    <h3 class="card-title page-header0"><i class="fa fa-briefcase"></i> Job Informations</h3>
                     <hr>
                     <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Name of the Company<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                               <input type="text" class="form-control">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Grade/Designation<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                           <select class="form-control">
                               <option>Sales Lead</option>
                               <option>Other Lead</option>
                           </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Date of Joining<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                          <input type="date" class="form-control">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Location<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                         <select class="form-control">
                            <option>Select Location</option>
                            <option>Pune</option>
                         </select>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Remark<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                        <textarea class="form-control"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-4">
                                <label for="aaaa">Level<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                      <input type="text" class="form-control">
                            </div>
                        </div>
                    </div>

              </div>
              
            </div>
            <div class="row">
                <div class="col-12 text-center">
                    <button class="btn btn-primary btn-sm">Submit</button>
                    <button class="btn btn-danger btn-sm ml-10">Cancel</button>
                </div>
            </div>











            <div class="row m-t-30">
                <div class="col-12">
                       <div class="table-responsive">
                           <table class="table">
                               <tr class="bg-primary text-white">
                                  <th>Sr No.</th>
                                  <th>Employee Code</th>
                                  <th>Employee Name</th>
                                  <th>Date of Birth</th>
                                  <th>Relationship</th>
                                  <th>Gender</th>
                                  <th>Designation</th>
                                  <th>Date of Joining</th>
                                  <th>Location</th>
                                  <th>Marital Status</th>
                                  <th>Remark</th>
                                  <th>Level</th>
                                  
                               </tr>
                               
                           </table>
                        </div>
                   </div>
            </div>

            
             
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

